if (!customElements.get('usg-testimonials')) {
  class UsgTestimonials extends HTMLElement {
    constructor() {
      super();

      const sliderElement = this.querySelector('.swiper-slider');

      this.slider = new Swiper(sliderElement, {
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 12,
        pagination: {
          el: '.ugc__testimonials-pagination',
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            autoHeight: false,
          },
        }
      });
    }
  }

  customElements.define('usg-testimonials', UsgTestimonials);
}